import { IColumns } from '../../../shared/util/base-table.util';

export interface TramiteTableColumnModel {
  id: string;
  empresa: string;
  estado: string;
  entidadProductivaId: number;
  description: string
}

export const tramiteTableColumns: IColumns<TramiteTableColumnModel>[] = [
  {
    caption: 'Trámite',
    field: {
      key: 'id'
    }
  },
  {
    caption: 'Empresa',
    field: {
      key: 'empresa'
    }
  },
  {
    caption: 'Estado',
    field: {
      key: 'estado'
    }
  },
  {
    caption: 'Descripción',
    field: {
      key: 'description'
    }
  }
];
